import { FC } from "react";
import { informationData } from "../configs";
import { InformationItem } from "./InformationItem";

export const Information: FC = () => {
  return (
    <>
      <h2 className="text-3xl md:text-4xl font-bold text-red-500 mx-6 mt-6 md:mt-10 mb-6">
        {informationData.title}
      </h2>
      <p className="text-lg mx-6 mb-6">{informationData.introduction}</p>
      {informationData.informationItems.map((infromationItem, index) => (
        <div key={index}>
          <InformationItem
            subtitle={infromationItem.subtitle}
            descriptions={infromationItem.descriptions}
            descriptionLink={infromationItem.descriptionLink}
            descriptionLinkText={infromationItem.descriptionLinkText}
          />
        </div>
      ))}
    </>
  );
};
